import { Tooltip } from '@chakra-ui/react';
import { Text } from 'components/v4';
import { CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { useMemo } from 'react';

const ColumnAutoSize = ({
    dataKey,
    parent,
    rowData,
    rowIndex,
    cache,
    isPhoneNumber,
}) => {
    const label = isPhoneNumber ? `+${rowData[dataKey]}` : rowData[dataKey];

    const defaultCache = useMemo(
        () =>
            new CellMeasurerCache({
                fixedWidth: true,
                defaultHeight: 30,
                minHeight: 30,
            }),
        [],
    );

    const cellCache = cache || defaultCache;

    if (
        !cellCache ||
        typeof cellCache.has !== 'function' ||
        typeof cellCache.set !== 'function' ||
        !parent
    ) {
        return (
            <div
                style={{
                    padding: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                    overflow: 'hidden',
                }}>
                <Tooltip label={label} hasArrow>
                    <span
                        style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}>
                        <Text as="span" isTruncated>
                            {label}
                        </Text>
                    </span>
                </Tooltip>
            </div>
        );
    }

    return (
        <CellMeasurer
            cache={cellCache}
            columnIndex={0}
            key={`${dataKey}-${rowIndex}`}
            parent={parent}
            rowIndex={rowIndex}>
            {({ measure, registerChild }) => (
                <div
                    ref={registerChild}
                    style={{
                        padding: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                        overflow: 'hidden',
                    }}
                    onLoadCapture={measure}>
                    <Tooltip label={label} hasArrow>
                        <span
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}>
                            <Text as="span" isTruncated>
                                {label}
                            </Text>
                        </span>
                    </Tooltip>
                </div>
            )}
        </CellMeasurer>
    );
};

export default ColumnAutoSize;
